import { render, staticRenderFns } from "./NextWeekDelivery.vue?vue&type=template&id=3b16513b&"
import script from "./NextWeekDelivery.vue?vue&type=script&lang=js&"
export * from "./NextWeekDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports